import { combineReducers } from '@reduxjs/toolkit';
import permission from './permissionSlice';

const permissionReducer = combineReducers({
	permission
});

export default permissionReducer;